import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Card,
  CardContent,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Gavel as GovernanceIcon,
  Assessment as AssessmentIcon,
  Policy as PolicyIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';

const GovernanceDashboard: React.FC = () => {
  const stats = [
    { title: 'Active Policies', value: '24', icon: <PolicyIcon />, color: '#003366' },
    { title: 'Data Quality Score', value: '87%', icon: <AssessmentIcon />, color: '#4caf50' },
    { title: 'Compliance Rate', value: '92%', icon: <CheckIcon />, color: '#2196f3' },
    { title: 'Open Issues', value: '12', icon: <GovernanceIcon />, color: '#ff9800' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 600,
            color: '#003366',
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <DashboardIcon sx={{ fontSize: 40 }} />
          Governance Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Monitor and manage your data governance program
        </Typography>
      </Box>

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: '100%',
                background: `linear-gradient(135deg, ${stat.color} 0%, ${stat.color}dd 100%)`,
                color: 'white',
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, color: 'white' }}>
                  {stat.icon}
                  <Typography variant="h6" sx={{ ml: 1, color: 'white', fontWeight: 600 }}>
                    {stat.title}
                  </Typography>
                </Box>
                <Typography variant="h3" sx={{ fontWeight: 700, color: 'white' }}>
                  {stat.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Main Content */}
      <Grid container spacing={3}>
        {/* Recent Activities */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
              Recent Activities
            </Typography>
            <Box sx={{ color: 'text.secondary' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • Policy "Data Classification" updated by Admin
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • Data Quality assessment completed for Customer domain
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • New data steward assigned to Finance domain
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • Compliance audit scheduled for next week
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Quick Actions */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
              Quick Actions
            </Typography>
            <Box sx={{ color: 'text.secondary' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Create new policy
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Run data quality assessment
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Submit governance request
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → View compliance reports
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Coming Soon Notice */}
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 4,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
              border: '2px dashed #003366',
            }}
          >
            <Typography variant="h5" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
              🚧 Dashboard Under Development
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              This page is a placeholder. Full governance dashboard functionality coming soon.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Features will include: Real-time metrics, Interactive charts, Workflow management,
              Alerts and notifications, Custom reports, and more.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GovernanceDashboard;
